import React from 'react'
import PropTypes from 'prop-types'
import l10n from '../../shared/l10n'

const {
  common: { readMore },
} = l10n

const DhsvTeaserboxItem = ({ row, data, list }) => {
  //console.log(data.bgcolor_picker) //eslint-disable-line
  return (
    <div
      //style={{ backgroundColor: data.bgcolor_picker }}
      //style={{ color: 'red' }}
      className={
        `blog-item teaserbox ${data.bgcolor} ${list ? ' list' : ''}` +
        (!['magazin_2_spalten_left', 'magazin_2_spalten_right'].includes(row)
          ? ' small'
          : '')
      }
    >
      <div className="inner">
        {list ? (
          <div
            className="image lazyload"
            {...(data.thumbnail ? { 'data-bg': data.thumbnail } : {})}
          />
        ) : (
          <a
            href={data.link.url}
            className="image lazyload"
            {...(data.thumbnail ? { 'data-bg': data.thumbnail } : {})}
          />
        )}
        <div className="meta" style={{ backgroundColor: data.bgcolor_picker }}>
          {data.title ? (
            <h3>
              {list ? (
                data.title
              ) : (
                <a
                  href={data.link.url}
                  dangerouslySetInnerHTML={{ __html: data.title }}
                />
              )}
            </h3>
          ) : null}
          {list ? (
            <ul className="more">
              {data.links.map(
                (el, i) =>
                  el.url !== '' && (
                    <a
                      style={{
                        color: data.bgcolor_picker_lines,
                        borderBottomColor: data.bgcolor_picker_lines,
                      }}
                      href={el.url}
                      target={el.target}
                      key={i}
                    >
                      {el.title ? el.title : readMore}
                    </a>
                  )
              )}
            </ul>
          ) : (
            data.link.url !== '' && (
              <div className="more">
                <a href={data.link.url}>
                  {data.link.title ? data.link.title : readMore}
                </a>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  )
}

DhsvTeaserboxItem.propTypes = {
  row: PropTypes.string,
  data: PropTypes.object,
  list: PropTypes.bool,
}

export default DhsvTeaserboxItem
